import { z } from 'zod'

import { REQUIRED_FIELD_MESSAGE } from '@/constants'

export const columnCreationSchema = z.object({
  column: z.object(
    { value: z.string().trim(), label: z.string().trim() },
    { required_error: REQUIRED_FIELD_MESSAGE }
  ),
})

export type ColumnCreationType = z.infer<typeof columnCreationSchema>

export const ALL_AVAILABLE_COLUMNS = [
  { value: 'itemLength', label: 'Длина изделия, см' },
  { value: 'itemWidth', label: 'Ширина изделия, см' },
  { value: 'itemHeight', label: 'Высота изделия, см' },
  { value: 'itemWeight', label: 'Вес изделия, кг' },
  { value: 'details', label: 'Описание' },
  { value: 'warranty', label: 'Гарантия, мес.' },
  { value: 'comment', label: 'Комментарий' },
  { value: 'multiplicity', label: 'Кратность' },
  { value: 'barcode', label: 'Штрихкод' },
  { value: 'unitOfMeasurement', label: 'Единица измерения' },
  { value: 'countryOfOrigin', label: 'Страна происхождения' },
]
